import { render, staticRenderFns } from "./DeliveryDriverEdit.vue?vue&type=template&id=36cd69eb&lang=pug&"
import script from "./DeliveryDriverEdit.vue?vue&type=script&lang=js&"
export * from "./DeliveryDriverEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports